import React from "react";
import { Row, Col, Container } from "reactstrap";

const Footer = () => {
  return (
    <React.Fragment>
              <footer className="Vendorfooter">
                  <Container fluid>
                        <Row>
                            <Col sm={12}>
                                <div >
                                {new Date().getFullYear()} © Absolin.
                                </div>
                            </Col>
                            
                        </Row>
                  </Container>
              </footer>
    </React.Fragment>
  );
};

export default Footer;
